module.exports = __webpack_public_path__ + "img/Weapon_220.f7d4de3b.png";